import { useState, useEffect, useRef } from "react";

import { Calendar, formatDate, formatRange } from '@fullcalendar/core'
import FullCalendar from '@fullcalendar/react' // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid' // a plugin!
import interactionPlugin from '@fullcalendar/interaction' // a plugin!
import timeGridPlugin from '@fullcalendar/timegrid'
import multiMonthPlugin from '@fullcalendar/multimonth'
import listPlugin from '@fullcalendar/list';
import customViewPlugin from './custom1';
import moment from 'moment';
// import ToastCalendar from './ToastCalendar';
// import MyCalendar from './BigCalendar';
import {Button, Modal, Row, Col, Form} from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.rtl.min.css';

import { useForm } from 'react-hook-form';
import Select from 'react-select';
import { AxiosGeneral } from './tools/AxiosBase';


import './App.css';

function App() {
    const calendarRef = useRef(null)
    // const handleDateClick = dateClickInfo => {
    //     calendarRef.current
    //         .getApi()
    //         .changeView('agenda', {
    //             start: '2017-06-01',
    //             end: '2017-06-05'
    //           })
    // };

    const [users, setUsers] = useState([])
    const [events, setEvents] = useState([])
    const colors = [
        { value: 'red', label: 'قرمز'},
        { value: 'green', label: 'سبز'},
        { value: 'blue', label: 'آبی'},
        { value: 'pink', label: 'بنفش'},
    ]

    // useEffect(() => {
    //     console.log('events:',events)
    // }, [events]);

    useEffect(() => {
        let events2 = [
            {
                id: -1,
                daysOfWeek: [4,5],
                display: 'background',
                color: "#8FBC8F50",
                overLap: false,
                allDay: true
            }
        ]

        AxiosGeneral.get('events')
        .then( res => {
            const data = res.data
            data.map(item => {
                events2.push({
                    id: item.id,
                    start: item.start,
                    end: item.end,
                    start_fa: item.start_fa,
                    end_fa: item.end_fa,
                    display: 'block',
                    color: item.color,
                    overLap: false,
                    title: item.title,
                    participants_fa: item.participants_fa,
                })
            })
            setEvents([ ...events2 ])
        })
        .catch( error => {
            console.log(error)
        })

        AxiosGeneral.get('users')
        .then( res => {
            let users2 = []
            const data = res.data
            data.map(item => {
                users2.push({
                    label: item.lastName + " - " + item.name,
                    value: item.id,
                })
            })
            setUsers(users2)
        })
        .catch( error => {
            console.log(error)
        })
    }, []);

    // const modalOpen = (xx) => {
    //     // alert('open')
    //     console.log('xx:',xx)
    //     setEvents([ ...events, {
    //             start: xx.startStr,
    //             end: xx.endStr,
    //             display: 'block',
    //             // display: 'list-item',
    //             color: "#FF0000",
    //             overLap: false,
    //             title: 'Test A.'
    //     }])
    // }

    const renderEventContent = (eventInfo) => {
        // console.log('eventInfo: ', eventInfo)
        let x = events.find(item => parseInt(item.id) === parseInt(eventInfo.event.id))
        return (
            <>
                <div className="tooltip1" dir="rtl" style={{backgroundColor:x?.color, borderColor:'blue', color:'#FFFFFF', padding:'3px 5px'}}>
                    <i>{eventInfo.event.title}</i>
                    <span className="tooltiptext" style={{textAlign:'left', marginTop:'20px', zIndex:999}}>
                        {/* <p style={{margin:'0',textAlign:'right'}}>عنوان: <b>{eventInfo.event.title}</b></p> */}
                        {
                            x?.participants_fa?.length > 0 &&
                            <p style={{margin:'0',textAlign:'right'}}>مشارکت کنندگان: <b>
                                {
                                    x?.participants_fa?.map((item,index) => {
                                        return (
                                            <span key={index}>{index>0 && " / "} {item}</span>
                                        )
                                    })
                                }    
                            </b></p>
                        }
                        {/* {
                            (x !== null && x !== undefined) ?
                            <>
                                <p style={{margin:'0',textAlign:'right'}}>شروع: <b><span style={{direction:'rtl'}}>{x.start_fa}</span></b></p>
                                <p style={{margin:'0',textAlign:'right'}}>پایان: <b>{x.end_fa}</b></p>
                            </>
                            : ""
                        } */}
                    </span>
                </div>
            </>
        )
    }

    /////////// HOOK-FORM
    const {
        register,
        // handleSubmit,
        formState: { errors },
    } = useForm();

    const handleSubmit = () => {
        setShow(false)
        newEventData.title = title
        
        AxiosGeneral.post('add-event',newEventData)
        .then( res => {
            const data = res.data
            setEvents([...events, {
                id: data.id,
                start: newEventData.start,
                end: newEventData.end,
                display: 'block',
                color: newEventData.color,
                overLap: false,
                title: newEventData.title
            }])
        })
        .catch( error => {
            console.log(error)
        })
    }

    const selectUser = (event, element) => {
        let users2 = event.map(item => item.value)
        setNewEventData({
            ...newEventData,
            user: users2
        })

    }

    const selectColor = (xx) => {
        setNewEventData({
            ...newEventData,
            color: xx
        })
    }

    const handleEventClick = (clickInfo) => {
        let checkEvent = events.find(item => item.id === parseInt(clickInfo.event.id))
        setDeleteEventModalShow(true)
        setDeleteEventId(clickInfo.event.id)
    }


    /////////// ADD MODAL
    const [newEventData, setNewEventData] = useState({
        start: null,
        end: null,
        title: null,
        user: null,
    })
    const [show, setShow] = useState(false);
    const [title, setTitle] = useState(null);

    const handleClose = () => setShow(false);
    const handleShow = (selectInfo) => {
        setShow(true);
        setNewEventData({
            // id: -1,
            start: selectInfo.startStr,
            end: selectInfo.endStr,
            title: 'SSSSS',
            user: [],
            color: 'blue',
        })
    }


    /////////// DELETE MODAL
    const [deleteEventId, setDeleteEventId] = useState(null)
    const [deleteEventModalShow, setDeleteEventModalShow] = useState(false);

    const deleteModalHandleClose = () => setDeleteEventModalShow(false);

    const deleteModalHandleShow = (selectInfo) => {
        setDeleteEventModalShow(true);
        setDeleteEventId(selectInfo.id)
    }
    
    const deleteSubmit = () => {
        AxiosGeneral.post('delete-event/' + deleteEventId)
        .then( res => {
            const data = res.data
            let events2 = events.filter(item => item.id !== parseInt(deleteEventId))
            setEvents(events2)
            setDeleteEventModalShow(false);
        })
        .catch( error => {
            console.log(error)
        })
    }

    const workSpec = [
        {
          daysOfWeek: [1, 2, 3, 4],
          startTime: '08:00',
          endTime: '18:00'
        },
        {
          daysOfWeek: [5],
          startTime: '09:00',
          endTime: '14:00'
        }
      ]

    return (
        <div style={{margin:'30px'}}>
            <Modal size="lg" show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title>ثبت فعالیت جدید</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col md="6">
                                <Form.Group className="mb-3">
                                    <Form.Label>زمان شروع</Form.Label>
                                    <Form.Control type="text" placeholder="..." style={{direction:'rtl'}} value={new Date(newEventData.start).toLocaleDateString('fa-IR')} readOnly/>
                                </Form.Group>
                            </Col>
                            <Col md="6">
                                <Form.Group className="mb-3">
                                    <Form.Label>عنوان فعالیت</Form.Label>
                                    <Form.Control type="text" placeholder="..." style={{direction:'rtl'}} onChange={(event, element) => setTitle(event.target.value)} />
                                </Form.Group>
                            </Col>
                            <Col md="6">
                                <Form.Group className="mb-3">
                                    <Form.Label>رنگ</Form.Label>
                                    <Select
                                        className='select-input'
                                        placeholder="..."
                                        options={colors}
                                        value={newEventData?.color ? colors.find(x => x.value === newEventData.color) : ''}
                                        onChange={option => selectColor(option ? option.value : option)}
                                    />
                                    {errors.language && <p>{errors.language.message}</p>}
                                </Form.Group>
                            </Col>
                            <Col md="6">
                                <Form.Group className="mb-3">
                                    <Form.Label>مشارکت کنندگان</Form.Label>
                                    <Select
                                        className='select-input'
                                        placeholder="..."
                                        isClearable
                                        options={users}
                                        value={newEventData?.user ? users.find(x => x.value === newEventData.user) : ''}
                                        // onChange={option => selectUser(option ? option.value : option)}
                                        onChange={ (event, element) => { selectUser(event, element) }}
                                        isMulti={true}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    لغو
                </Button>
                <Button variant="primary" onClick={handleSubmit}>
                    ثبت
                </Button>
                </Modal.Footer>
            </Modal>

            <FullCalendar
                plugins={[multiMonthPlugin,dayGridPlugin, timeGridPlugin, interactionPlugin, customViewPlugin, listPlugin]}
                headerToolbar={{
                    left: 'prev,next today',
                    center: 'title',
                    // right: 'dayGridMonth,timeGridWeek,timeGridDay,multiMonthYear,custom'
                    right: 'multiMonthYear,dayGridMonth,timeGridWeek,timeGridDay,listWeek'
                }}
                firstDay={6}
                editable={true}
                selectable={true}
                selectMirror={true}
                dayMaxEvents={false}
                weekends={true}
                events= {events}
                showNonCurrentDates= {false}
                locale="fa"
                direction="rtl"
                buttonText =  {{
                    today:    'امروز',
                    year:    'سال',
                    month:    'ماه',
                    week:     'هفته',
                    day:      'روز',
                    list:     'فعالیتها'
                }}
                // dateClick={handleDateClick}
                ref={calendarRef}
                // businessHours={workSpec}
                slotMinTime="06:00:00"
                slotMaxTime="21:00:00"
                // businessHours= {{
                //     // days of week. an array of zero-based day of week integers (0=Sunday)
                //     daysOfWeek: [ 1, 2, 3, 4 ], // Monday - Thursday
                  
                //     startTime: '10:00', // a start time (10am in this example)
                //     endTime: '18:00', // an end time (6pm in this example)
                //   }}
                  
                // duration= {{ days: 3 }}
                // initialEvents={INITIAL_EVENTS} // alternatively, use the `events` setting to fetch from a feed
                select={(e) => handleShow(e)}
                eventContent={renderEventContent} // custom render function
                eventClick={(e) => handleEventClick(e)}
                // eventsSet={this.handleEvents} // called after events are initialized/added/changed/removed
                /* you can update a remote database when these fire:
                eventAdd={function(){}}
                eventChange={function(){}}
                eventRemove={function(){}}
                */
            />

            <Modal size="lg" show={deleteEventModalShow} onHide={deleteModalHandleClose}>
                <Modal.Header closeButton>
                <Modal.Title>حذف فعالیت</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form onSubmit={deleteSubmit}>
                        <Row>
                            {
                                deleteEventId !== null && events?.find(item => item.id === parseInt(deleteEventId)) !== undefined &&
                                <>
                                    <p>
                                        <span>شما قصد حذف فعالیت </span>
                                        <span style={{fontWeight:'bold'}}>{events?.find(item => item.id === parseInt(deleteEventId)).title}</span>
                                        <span> را دارید. آیا مطمئن هستید؟ </span>
                                    </p>
                                    <p style={{color:'red'}}>در صورت حذف، فعالیت غیر قابل بازگشت است.</p>
                                </>
                                
                            }
                        </Row>
                    </Form>
                </Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={deleteModalHandleClose}>
                    لغو
                </Button>
                <Button variant="primary" onClick={deleteSubmit}>
                    حذف
                </Button>
                </Modal.Footer>
            </Modal>
        </div>

        // <div>
        //     <ToastCalendar usageStatistics={false} />
        // </div>
    );
}

export default App;
